import { Box, Notification, Text } from '@bfa/common-ui';
import React from 'react';

import { DEFAULT_ERROR_MESSAGE } from '../../features/Upgrades/constants';
import { Maybe, Scalars } from '../../gql.generated';

const ErrorBanner = ({
  show,
  errorMsg,
}: {
  show?: boolean;
  errorMsg?: Maybe<Scalars['String']['output']>;
}) => {
  if (!show) return null;
  return (
    <Box marginTop={['2rem', '3rem']} marginBottom="2rem">
      <Notification icon="icon-ipsy-error" type="error" primary={false}>
        <Text
          bold
          dangerouslySetInnerHTML={{
            __html: errorMsg ?? DEFAULT_ERROR_MESSAGE,
          }}
        />
      </Notification>
    </Box>
  );
};

export default ErrorBanner;
